// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"c00ae390","398":"641a76a6","453":"98604449","713":"ad4920c2"}[chunkId] + ".chunk.js";
};